import { A, useLocation } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { t, tPlural } from '../../i18n';
import { type EmailRoutesResponse, useEmailRoutes } from '../../lib/emailRoutes';
import { orgFromPath, orgHref } from '../../lib/org';
import { QueryBoundary } from '../QueryBoundary';
import { Skeleton } from '../Skeleton';

// "For the whole team": where the ACCOUNT's email goes, read-only, with a link
// to the Email routes page that edits it. Mounted for owners only
// (`canManageTeamEmail`), so a member never issues this read. The Email routes
// page stays separate: it lists raw category keys, which this page never shows.

function exceptionsLine(data: EmailRoutesResponse): string {
  const count = data.data.filter((route) => route.is_override).length;
  if (count === 0) return t('notifications_settings.send_to.team_exceptions_none');
  return tPlural('notifications_settings.send_to.team_exceptions', count, { count });
}

export function NotificationTeamEmail(props: { readonly token: string | null }): JSX.Element {
  const query = useEmailRoutes(props.token);
  const location = useLocation();

  return (
    <div class="notification-send-to__team">
      <h3 class="notification-send-to__label">{t('notifications_settings.send_to.team_label')}</h3>
      <QueryBoundary query={query} loading={<Skeleton height="3rem" />}>
        {(data) => (
          <>
            <p class="notification-send-to__value">
              {data.default_email === null
                ? t('notifications_settings.send_to.team_default_none')
                : t('notifications_settings.send_to.team_default', {
                    address: data.default_email,
                  })}
            </p>
            <p class="card__desc">{exceptionsLine(data)}</p>
            <A href={orgHref('/account/email-routes', orgFromPath(location.pathname))}>
              {t('notifications_settings.send_to.team_link')}
            </A>
          </>
        )}
      </QueryBoundary>
    </div>
  );
}
